import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onConnect, isConnecting }) => {
  const incomeCards = [
    {
      percent: '40%',
      title: 'Instant Sponsor Income',
      desc: 'Get instant rewards when you refer new members. No waiting, no delays - pure instant earnings!',
      icon: '💰',
      color: '#ff6b6b'
    },
    {
      percent: '30%',
      title: 'Level Income',
      desc: '2 Matrix Spill Over for 10 Levels. Each level gives you 3% earnings for unlimited depth!',
      icon: '📈',
      color: '#4ecdc4'
    },
    {
      percent: '25%',
      title: 'Pool Income',
      desc: 'Daily passive income from the global pool. Earn while you sleep with our automated distribution!',
      icon: '🌊',
      color: '#ffe66d'
    },
    {
      percent: '5%',
      title: 'Royalty Income',
      desc: 'Exclusive royalty rewards for top performers. Achieve greatness and unlock premium benefits!',
      icon: '👑',
      color: '#ff8c00'
    }
  ];

  return (
    <div className="welcome-screen">
      {/* Header Section */}
      <div className="welcome-header">
        <div className="welcome-portal">
          <div className="portal-glow"></div>
          <div className="portal-center">
            <img src="/assets/gifs/1.gif" alt="Time Portal" className="portal-gif" />
          </div>
        </div>

        <div className="welcome-content">
          <h1 className="welcome-title">
            <span className="title-main">TIME TO TIME</span>
          </h1>
          
          <p className="welcome-tagline">Journey Through the DeFi Continuum</p>
          
          <div className="welcome-features">
            <div className="feature-pill">
              <span className="feature-icon">⏰</span>
              <span>Time-Based Rewards</span>
            </div>
            <div className="feature-pill">
              <span className="feature-icon">🌀</span>
              <span>Portal Matrix</span>
            </div>
            <div className="feature-pill">
              <span className="feature-icon">💎</span>
              <span>3x Earnings</span>
            </div>
          </div>

          <button 
            className="connect-btn" 
            onClick={onConnect}
            disabled={isConnecting}
          >
            {isConnecting ? (
              <>
                <span className="btn-spinner"></span>
                <span>Entering Portal...</span>
              </>
            ) : (
              <>
                <span className="btn-icon">🚀</span>
                <span>Enter Time Portal</span>
              </>
            )}
          </button>

          <p className="welcome-hint">Connect your wallet to begin the journey</p>
        </div>
      </div>

      {/* Income Details Section */}
      <div className="income-details-section">
        <div className="section-divider">
          <span className="divider-icon">⚡</span>
          <span className="divider-text">Earning Opportunities</span>
          <span className="divider-icon">⚡</span>
        </div>

        <div className="income-cards-grid">
          {incomeCards.map((card, index) => (
            <div 
              key={index} 
              className="income-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="card-icon-wrap" style={{ background: `linear-gradient(135deg, ${card.color}, ${card.color}aa)` }}>
                <span className="card-icon">{card.icon}</span>
              </div>
              <div className="card-percent" style={{ color: card.color }}>{card.percent}</div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="cta-buttons">
          <a href="https://t.me/timetotime" target="_blank" rel="noopener noreferrer" className="cta-btn telegram">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .37z"/>
            </svg>
            <span>Join Telegram</span>
          </a>
          <a href="/plan.pdf" target="_blank" className="cta-btn download">
            <span>📄</span>
            <span>Download Plan</span>
          </a>
        </div>
      </div>

      {/* Floating Particles */}
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${5 + Math.random() * 5}s`
          }} />
        ))}
      </div>
    </div>
  );
};

export default WelcomeScreen;
